import * as React from "react";

export interface PaymentField {
  field: string;
  label: string;
  placeholder?: string;
  validation?: RegExp;
  maxLength?: number;
  error?: string;
  required?: boolean;
  tag: string;
  defaultValue?: string;
  format?: (value: string) => any;
  pattern?: string;
  showErrors?: boolean;
}

export const creditCardName: Array<PaymentField> = [
  {
    field: "name",
    label: "Name on Card",
    tag: "customer_name_field",
    placeholder: "Name on Card",
    required: true
  }
]

export const eCheckNameBusiness: Array<PaymentField> = [
  {
    field: "name",
    label: "Name",
    tag: "customer_bank_account_holder_name",
    placeholder: "Name"
  },
];

export const eCheckNameIndividual: Array<PaymentField> = [
  {
    field: "given_name",
    label: "First Name",
    tag: "customer_bank_account_holder_firstname",
    placeholder: "First Name"
  },
  {
    field: "surname",
    label: "Last Name",
    tag: "customer_bank_account_holder_lastname",
    placeholder: "Last Name"
  }
];
export const paymentFields: Array<PaymentField> = [
  {
    field: "reference",
    label: "Reference",
    tag: "reference_field",
    placeholder: "Example: Invoice 123",
    maxLength: 128
  },
  {
    field: "email",
    label: "Email",
    tag: "customer_email_field",
    placeholder: "Email",
    validation: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
    error: "Invalid Email Address"
  },
  // {
  //   field: "name",
  //   label: "Name on Card",
  //   tag: "customer_name_field",
  //   placeholder: "Name on Card"
  // },
  // {
  //   field: "name",
  //   label: "Name",
  //   tag: "customer_bank_account_holder_name",
  //   placeholder: "Name"
  // },
  {
    field: "address1",
    label: "Billing Address",
    tag: "customer_address_field",
    placeholder: "Billing Address"
  },
  {
    field: "address2",
    label: "Apt / Suite",
    tag: "customer_address2_field",
    placeholder: ""
  },
  {
    field: "country",
    label: "Country",
    tag: "customer_country_field",
    placeholder: ""
  },
  {
    field: "city",
    label: "City",
    placeholder: "Austin",
    tag: "customer_city_field"
  },
  {
    field: "state",
    label: "State",
    placeholder: "TX",
    tag: "customer_state_field",
    validation: /^[A-Z]{2}$/,
    maxLength: 2
  },
  {
    field: "postal_code",
    label: "Zip / Postal Code",
    tag: "customer_postalcode_field",
    placeholder: "Zip / Postal Code",
    validation: /^[\w\d\s-]{3,9}$/,
    error: "Invalid Postal Code",
    required: true
  },
  {
    field: "phone",
    label: "Phone",
    tag: "customer_phone_field",
    placeholder: "Phone",
    maxLength: 22
  }
];



// WEBPACK FOOTER //
// ./src/checkout/fields/PaymentField.tsx